import { UnaryNode } from './unaryNode';
export class IdentityNode extends UnaryNode {
    constructor(attributes, inputs, outputs, constants, onnxVersion, mode) {
        super(attributes, inputs, outputs, constants, onnxVersion, 'Identity', mode);
    }
    compute(x) {
        return x.copy();
    }
}
//# sourceMappingURL=identity.js.map